(function( $ ) {

    $( document ).ready( function() {

        const { __, _x, _n, _nx } = wp.i18n;

        if ( $( '#arr_dep_load_items' ).length > 0 ) {

            let type = 'A';
            let currPage = 1;
            let itemsPerPage = 20;
            let totalPages = 1;
            let nextPage = 1;

            $( '#arr_dep_load_items' ).click( function() {
                const btn = $(this);
                const flightsTable = $('#flights_table tbody');

                if ( currPage == 1 ) {
                    type = btn.attr('data-type');
                    itemsPerPage = btn.attr('data-itemsperpage');
                    totalPages = btn.attr('data-totalpages');
                    nextPage = btn.attr('data-nextpage');
                }

                if ( currPage < totalPages ) {

                    //load more flight items
                    let flightData = {
                        'arr_dep'  : type,
                        'limit'    : itemsPerPage,
                        'page'     : nextPage
                    };

                    flightData = JSON.parse( JSON.stringify( flightData ) );
                    $.ajax({
                        type      : "POST",
                        url       : "/wp-admin/admin-ajax.php",
                        dataType  : "JSON",
                        data      : {
                            action: "arr_dep_load_more",
                            data: flightData,
                        },
                        success:function( resp ) {
                            // This outputs the result of the ajax request
                            if (resp.success == false) {
                                //hide Load more button
                                btn.hide();
                            } else {
                                //load new flights items - table tr
                                const info = resp.data;
                                const items = resp.data.docs;

                                nextPage = info.nextPage;
                                currPage = info.page;

                                let itemRow;
                                let date;
                                let time;

                                $.each( items, function ( key, item ) {

                                    itemRow = '<tr>';
                                    itemRow += '<td class="hide-mobile">' + item.planned_date + '</td>';
                                    itemRow += '<td class="hide-mobile">' + item.planned_time + '</td>';
                                    itemRow += '<td class="hide-desktop">'
                                            + '<p></p>'
                                            + '<p></p></td>';
                                    itemRow += '<td class="rectangle"><span class="rectangle-filled"></span></td>';
                                    itemRow += '<td>' + item.flight + '</td>';
                                    itemRow += '<td>' + item.airport_name_eng1 + '</td>';
                                    itemRow += '<td class="hide-mobile">' + item.terminal + '</td>';
                                    itemRow += '<td class="hide-mobile">' + item.aircomp_code + '</td>';
                                    /**
                                        * !!!! TO DO:
                                        * STATUS content to be from API
                                        *
                                        */
                                    itemRow += '<td class="hide-mobile"></td>';
                                    itemRow += '<td><span class="info">' + __( 'Flight info', 'sofia-airport' ) + '</span><i class="fas fa-arrow-right"></i></td>';

                                    itemRow += '</tr>';

                                    flightsTable.append(itemRow);

                                });

                                if ( currPage == totalPages ) {
                                    btn.hide();
                                }

                            }
                        },
                        error: function( errorThrown ){
                            //Returns the thrown error
                            //hide Load more button
                            btn.hide();
                        }
                    });
                } else {
                    //hide Load more button
                    btn.hide();
                }
            });
        }
    });
})( jQuery );